import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import api from '../../utils/api';
import './JobApplication.css';

const JobApplication = ({ onClose }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    zipCode: '',
    experience: '',
    description: '',
    cv: null,
    documents: []
  });

  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.name === 'cv') {
      setFormData(prev => ({
        ...prev,
        cv: e.target.files[0]
      }));
    } else if (e.target.name === 'documents') {
      setFormData(prev => ({
        ...prev,
        documents: Array.from(e.target.files)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('email', formData.email);
      data.append('phone', formData.phone);
      data.append('address', formData.address);
      data.append('city', formData.city || '');
      data.append('zipCode', formData.zipCode || '');
      data.append('experience', String(parseInt(formData.experience, 10) || 0));
      data.append('description', formData.description || '');
      if (formData.cv) {
        data.append('cv', formData.cv);
      }
      formData.documents.forEach((file) => {
        data.append('documents', file);
      });

      const response = await api.post('/jobseekers/upload', data);

      if (response.data.success) {
        setMessage('Application submitted successfully!');
        setTimeout(() => {
          onClose();
          setFormData({
            name: '',
            email: '',
            phone: '',
            address: '',
            city: '',
            zipCode: '',
            experience: '',
            description: '',
            cv: null,
            documents: []
          });
          setMessage('');
        }, 2000);
      } else {
        setMessage(response.data.message || 'Error submitting application. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting application:', error);
      const errorMessage = error.response?.data?.message || 'Error submitting application. Please try again.';
      setMessage(errorMessage);
    }
  };

  return (
    <div className="job-application">
      <div className="job-application-header">
        <h2>{t('careers.titlejob', 'Titlejob')}</h2>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>

      <form onSubmit={handleSubmit} className="job-application-form">
        <div className="form-group">
          <label>{t('careers.fullName', 'FullName')}</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>{t('careers.email', 'Email')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>{t('careers.phone', 'Phone')}</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>{t('careers.address', 'Address')}</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />
        </div>

    <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="form-group">
            <label>{t('careers.zipCode', 'Zip Code')}</label>
            <input
              type="text"
              name="zipCode"
              value={formData.zipCode}
              onChange={handleChange}

            />
          </div>

              
          <div className="form-group">
            <label>{t('careers.city', 'City')}</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
  
            />
          </div>
        </div>

        <div className="form-group">
          <label>{t('careers.experience', 'Experience')}</label>
          <input
            type="number"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>{t('careers.description', 'Description')}</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}

            rows="4"
          />
        </div>

        <div className="form-group">
          <label>{t('careers.cv', 'Cv')}</label>
          <input
            type="file"
            name="cv"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            required
          />
        </div>

        <div className="form-group">
          <label>{t('careers.documents', 'Documents')}</label>
          <input
            type="file"
            name="documents"
            accept=".pdf,.doc,.docx"
            multiple
            onChange={handleFileChange}
          />
        </div>

        {message && (
          <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
            {message}
          </div>
        )}

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">{t('careers.submit', 'Submit')}</button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('careers.cancel', 'Cancel')}</button>
        </div>
      </form>
    </div>
  );
};

export default JobApplication;
